import { Button, Menu } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import React, { useState } from "react";
import { ChevronDown, Edit, LiveView, Lock, Trash } from "tabler-icons-react";
import { User } from "types";
import styles from "./ActionsBtn.module.css";
import EditRoleModal from "./EditRoleModal";
import ChangeCredentialsModal from "./ChangeCredentialsModal";
import { useNavigate } from "react-router-dom";
import { useDeleteUserOrganization } from "api/users/deletemember";

type ActionsBtnProps = {
  member: User<string>;
  orgId: string;
};

function ActionsBtn({ member, orgId }: ActionsBtnProps) {
  const [opened, setOpened] = useState(false);
  const [credentialsModalOpened, setCredentialsModalOpened] = useState(false);
  const navigate = useNavigate();
  const { mutate: deleteUserOrganization, isLoading } =
    useDeleteUserOrganization();

  const handleRemoveMember = () => {
    if (!member?._id || !orgId) return;

    deleteUserOrganization(
      { userId: member._id, organizationId: orgId },
      {
        onSuccess: () => {
          showNotification({
            title: "Member Removed",
            message: `${member.firstName ?? "User"} removed successfully`,
            color: "green",
          });
        },
        onError: (error) => {
          showNotification({
            title: "Error",
            message:
              (error.response?.data as { message?: string })?.message ??
              "Failed to remove member",
            color: "red",
          });
        },
      }
    );
  };

  return (
    <>
      <Menu>
        <Menu.Target>
          <Button
            variant="outline"
            rightIcon={<ChevronDown size={16} />}
            pl={10}
            pr={6}
            miw={95}
            size="sm"
            loading={isLoading}
          >
            Actions
          </Button>
        </Menu.Target>

        <Menu.Dropdown fw={400}>
          <Menu.Item
            icon={<LiveView size={18} />}
            onClick={() => navigate(`/user-profile/${member._id}`)}
          >
            View Profile
          </Menu.Item>

          <Menu.Item icon={<Edit size={18} />} onClick={() => setOpened(true)}>
            Edit Role
          </Menu.Item>

          <Menu.Item
            icon={<Lock size={18} />}
            onClick={() => setCredentialsModalOpened(true)}
          >
            Change Credentials
          </Menu.Item>

          <Menu.Item
            icon={<Trash size={18} />}
            color="red.8"
            onClick={handleRemoveMember}
          >
            Remove Member
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>

      <EditRoleModal
        opened={opened}
        onClose={() => setOpened(false)}
        member={member}
        orgId={orgId}
      />

      <ChangeCredentialsModal
        opened={credentialsModalOpened}
        onClose={() => setCredentialsModalOpened(false)}
        member={member}
      />
    </>
  );
}

export default ActionsBtn;
